import React from 'react';
const calendarIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg';
const carIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-rouded.svg';
const vaccineIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/vaccine-rouded.svg';
const examIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/exam-icon.svg';
const pinIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg';
const homeIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home-icon.svg';
const ConferenceIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conference-cam.svg';
const PatientIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg';

import * as S from '../../styles';
import { AppointmentInfo, CareTypes, CARE_TYPES_MAPPED, SCHEDULES_TYPES_MAPPED } from '../..';
import { formatDatetime } from '../../../../utils/dates';
import Info from '../Info';
import { HeadTypeByName } from '../HeadTypeByName';

export const ICON_BY_SCHEDULE_TYPE = {
  EXAM: examIcon,
  IMMUNIZATION: vaccineIcon,
  DEFAULT: PatientIcon
};

const CARE_TYPES_ICON = {
  PRESENTIAL: pinIcon,
  EINSTEIN_TO_YOU: homeIcon,
  TELEMEDICINE: ConferenceIcon,
  DRIVE_THRU: carIcon
};

type AppointmentSGHProps = {
  appointment: AppointmentInfo;
};

export const AppointmentSGH: React.FC<AppointmentSGHProps> = ({ appointment }) => {
  const handleTitle = () => {
    if (!appointment?.scheduleType) return '';
    if (appointment?.product.name.toUpperCase().includes('TELETRIAGEM CLÍNICA')) return 'Consulta';
    if (appointment?.product.name.toUpperCase().includes('DOAÇÃO DE SANGUE')) return 'Consulta';
    if (appointment?.product.name.toUpperCase().includes('SANGRIA TERAPÊUTICA')) return 'Consulta';
    if (appointment?.product.name.toUpperCase().includes('CHECK-UP')) return 'Consulta Check-up';
    if (appointment?.product.name.toUpperCase().includes('CHECK UP')) return 'Consulta Check-up';
    if (appointment?.resource?.name.includes('CHECK UP')) return 'Consulta Check-up';
    if (appointment?.resource?.name.includes('CHECK-UP')) return 'Consulta Check-up';
    if (appointment?.patient.isPregnant) return `Consulta ${appointment.product.name} - Pré Natal`;
    return SCHEDULES_TYPES_MAPPED[appointment?.scheduleType];
  };

  let dateAppointment = '';
  if (appointment?.date && appointment.hour) dateAppointment = `${appointment.date}T${appointment.hour}`;

  const handleTitleByCareType = (
    careType: 'PRESENTIAL' | 'EINSTEIN_TO_YOU' | 'TELEMEDICINE' | 'DRIVE_THRU',
    unitName?: string
  ) => {
    if (careType === CareTypes.TELEMEDICINE) return CARE_TYPES_MAPPED.TELEMEDICINE;
    if (careType === CareTypes.PRESENTIAL) return unitName;
    if (careType === CareTypes.DRIVE_THRU) return `${CARE_TYPES_MAPPED.DRIVE_THRU} ${unitName}`;
    return unitName;
  };

  return (
    <S.Schedule>
      <HeadTypeByName name={handleTitle()} appointment={appointment} />
      <Info
        icon={<img src={calendarIcon} />}
        title="Data"
        subtitle={dateAppointment && formatDatetime(new Date(dateAppointment))}
      />
      <Info
        icon={<img src={CARE_TYPES_ICON[appointment?.careType] || CARE_TYPES_ICON.PRESENTIAL} />}
        title="Local"
        subtitle={handleTitleByCareType(appointment?.careType, appointment.unit?.name) || ''}
        adress={appointment?.careType !== CareTypes.TELEMEDICINE ? appointment?.unit?.addressLine1 : undefined}
        local={appointment?.careType !== CareTypes.TELEMEDICINE ? appointment?.unit?.addressLine2 : undefined}
        link={appointment?.careType === CareTypes.TELEMEDICINE ? appointment.virtualAppointmentUrl : undefined}
      />
    </S.Schedule>
  );
};
